import { Box } from "@mui/material";
import { forwardRef } from "react";
import { ImageProps } from "./types";

export const Image = forwardRef<HTMLDivElement, ImageProps>((props, ref) => {
    const {
        src,
        alt,
        caption,
        width = "300px",
        height = "300px",
        objectFit = "cover",
        alignment = "center",
        borderRadius = "8px",
        shadow = false,
    } = props;

    return (
        <Box
            ref={ref}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems:
                    alignment === "center" ? "center"
                    : alignment === "right" ? "flex-end"
                    : "flex-start",
            }}
        >
            <Box
                component="img"
                src={src}
                alt={alt}
                sx={{
                    width,
                    height,
                    objectFit,
                    borderRadius,
                    boxShadow: shadow ? "0 4px 8px rgba(0, 0, 0, 0.1)" : "none",
                    maxWidth: "100%",
                }}
            />
            {caption && (
                <Box
                    component="figcaption"
                    sx={{
                        mt: 1,
                        fontSize: "0.875rem",
                        color: "text.secondary",
                        textAlign: alignment,
                    }}
                >
                    {caption}
                </Box>
            )}
        </Box>
    );
});

Image.displayName = "Image";
